import React, { useEffect, useState } from 'react';
import './VerifyOTP.css'; 
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../Components/Loader/Loader';
import leftArrow from '../../assets/vector.png';
import axiosUserInstance from '../../axiosUserInstance';
import { SEO } from '../../Utils/Constant';
import { Helmet } from 'react-helmet';

const VerifyOTP = ({isReset}) => {
    const registeredEmail = localStorage.getItem('signupEmail');
    const email = localStorage.getItem('forgetPasswordEmail');
    const [isLoading, setIsLoading] = useState(false);
    const [resendTimer, setResendTimer] = useState(600);
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const isVerify = location.state;

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

    useEffect(() => {
        if (resendTimer > 0) {
            const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [resendTimer]);

    const handleResend = async () => {
        setResendTimer(600);
        const emailValue = isReset === 'reset' ? email : registeredEmail;
        try {
            setIsLoading(true);
            const res = await axiosUserInstance.post('/auth/forgotpassword', {email: emailValue});
            setIsLoading(false);
            toast.success(res?.data?.message);
        } catch (error) {
            setIsLoading(false);
            toast.error(error?.response?.data?.error);
            console.error('Error from Signup',error);
        }
    };
    
    useEffect(() => {
        if(!isVerify){
            navigate('/login');
        }
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 576);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!code.trim()) {
            setError('Please enter your OTP');
            toast.error('Please enter your OTP');
            return; 
        }
    
        if (code.length < 6) {
            setError('OTP must be exactly 6 digits.');
            toast.error('OTP must be exactly 6 digits.');
            return; 
        }
        
        
        if (isReset === 'reset') {
            const data = {
                email:  email,
                otp: code
            };

            try {
                setIsLoading(true);
                const res = await axiosUserInstance.post('/auth/verify-otp', data, {skipAuth: true});
                setIsLoading(false);
                toast.success(res?.data?.message);
                if(res?.statusText == 'OK'){
                    navigate('/reset-password', { state: true });
                } else {
                    return;
                }
            } catch (error) {
                setIsLoading(false);
                toast.error(error?.response?.data?.error);
                console.error('Error from Reset password',error);
            }
        } else {
            const data = {
                email: registeredEmail,
                otp: code
            };

            try {
                setIsLoading(true);
                const res = await axiosUserInstance.post('/auth/verify-otp', data, {skipAuth: true});
                setIsLoading(false);
                toast.success(res?.data?.message);
                if(res?.statusText == 'OK'){
                    localStorage.removeItem('signupEmail');
                    navigate('/login');
                } else {
                    return;
                }
            } catch (error) {
                setIsLoading(false);
                toast.error(error?.response?.data?.error);
                console.error('Error from Signup',error);
            }
            
        }
    };

    const handleChange = (e) => {
        const input = e.target.value;
        if (/^\d{0,6}$/.test(input)) {
            setCode(input);
            if (input.length < 6) {
                setError('OTP must be exactly 6 digits.');
            }else if(!input.trim()){
                setError('Please enter your OTP');
            } else {
                setError('');
            }
        }
    };

    const goBack = () => {
        window.history.back();
    };

    return (
        <>
            <Helmet>
                <title>{SEO.VERIFY_OTP_PAGE.TITLE}</title>
                <meta name="description" content={SEO.VERIFY_OTP_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.VERIFY_OTP_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={SEO.VERIFY_OTP_PAGE.CANONICAL} />
                        
                <meta property="og:title" content={SEO.VERIFY_OTP_PAGE.TITLE} />
                <meta property="og:description" content={SEO.VERIFY_OTP_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.VERIFY_OTP_PAGE.OG.TYPE} />
                <meta property="og:url" content={SEO.VERIFY_OTP_PAGE.OG.URL} />
                <meta property="og:site_name" content={SEO.VERIFY_OTP_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
                        
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.VERIFY_OTP_PAGE.TWITTER.TITLE} />
                <meta name="twitter:description" content={SEO.VERIFY_OTP_PAGE.TWITTER.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />
                        
                <script type="application/ld+json">
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'WebPage',
                        'name': 'Verify OTP | OhMyFood',
                        'description': 'Secure OTP verification page to confirm your identity and grant account access on OMF.',
                        'url': 'https://omyfood.io/verify-otp',
                        'breadcrumb': {
                            '@type': 'BreadcrumbList',
                            'itemListElement': [
                                {
                                    '@type': 'ListItem',
                                    'position': 1,
                                    'name': 'Home',
                                    'item': 'https://omyfood.io'
                                },
                                {
                                    '@type': 'ListItem',
                                    'position': 2,
                                    'name': 'Verify OTP',
                                    'item': 'https://omyfood.io/verify-otp'
                                }
                            ]
                        }
                    },)}
                </script>
            </Helmet>
                        
            <div className="verify-container">
                {isLoading && <Loader/>}
                <div className='back-drop'></div>
                {isMobile ? <div className="mobile-verify-account-header">
                    <div className="verify-account-title">
                        <img src={leftArrow} alt="left-arrow" className='left-side-arrow' onClick={goBack}/>
                        <h2>Verify Account</h2>
                        <div></div>
                    </div>
                    <div className="verify-account-text">
                        <p>Sign up to food deliver right to your doorstep with just a few taps on your phone, saving you time and effort.</p>
                    </div>
                </div> : <></>}
                <div className="verify-card">
                    {!isMobile && 
                    <>
                        <h2>Verify Account</h2>
                        <p>Sign up to food delivery right to your doorstep with just a few taps on your phone, saving you time and effort.</p>
                    </>}
                    <p>Code has been sent to <strong>{isReset === 'reset' ? email : registeredEmail }</strong>. Enter the code to verify your account.</p>

                    <form onSubmit={handleSubmit}>
                        <div className='form-group'>
                            <label className='label-text' htmlFor='email'>Enter Code</label>
                            <input
                                type="text"
                                placeholder="6 Digit Code"
                                value={code}
                                onChange={handleChange}
                                className={error ? 'input-error' : ''}
                            />
                            {error && <span className="error-message">{error}</span>}
                        </div>
                        <button
                            type="submit" 
                            className="submit-button" 
                        >
                                    Submit
                        </button>
                    </form>
                    <div className="resend-section">
                        <p>
                                Didn&apos;t Receive Code?{' '}
                            {resendTimer > 0 ? (
                                <span>Resend code in {Math.floor(resendTimer / 60) < 10 && 0}{Math.floor(resendTimer / 60)}:{(resendTimer % 60).toString().padStart(2, '0')}</span>
                            ) : (
                                <button className="resend-button" onClick={handleResend}>Resend Code</button>
                            )}
                        </p>
                    </div>
                </div>
            </div>  
        </>
    );
};

export default VerifyOTP;
